const React = require('react');
const noop = require('mn-utils/noop');
const upperFirst = require('mn-utils/upperFirst');

const withState = require('../../../../../../utils/withState');

const Loading = require('../../../../Loading');
const Tooltip = require('../../../../Tooltip/B');
const {AdminStaticTableWithScroll} = require('../../../AdminStaticTable');

const {AdminSubtitle} = require('../../../AdminLayout');
const {BtnAddNew} = require('../../../Buttons');

const openEditWalletPopup = require('./utils/openEditWalletPopup');
const openNewWalletPopup = require('./utils/openNewWalletPopup');
const openDeleteWalletPopup = require('./utils/openDeleteWalletPopup');

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    loading: true
  }

  const getWalletsData = () => {
    setState({loading: true});
    const params = self.props.params || {};
    const tableDataRequest = self.props.tableDataRequest || noop;
    return tableDataRequest({id: params.id})
      .then((res) => {
        setState({loading: false, data: res});
      })
  }

  onMount(getWalletsData);

  return (state, props) => {
    return (
      <div className="w60 h60 rlv mt20 mhAuto">
        <Loading className="(c0)>.MuiCircularProgress-svg" />
      </div>
    )

    const {loading, data} = state;

    if (loading) return <Loading/>;

    const update = self.update;
    const {
      walletRequestCreate = noop,
      walletRequestUpdate = noop,
      walletRequestDelete = noop
    } = props;

    return (
      <>
        <div className="layoutRow jcSB aiC mt20">
          <AdminSubtitle text="Wallet List" />
          <BtnAddNew
            text="Add new wallet"
            onClick={() => openNewWalletPopup({
              request: walletRequestCreate,
              update
            })}
          />
        </div>
        <AdminStaticTableWithScroll
          maxHeight={240}
          cols={[
            {title: 'Coins', key: 'coin'},
            {title: 'Network', key: 'network'},
            {title: 'Address', handleCol: ({address}) => (<Tooltip>{address}</Tooltip>)},
            {title: 'Mapped to', handleCol: ({mapped_to}) => upperFirst(mapped_to)}
          ]}
          items={data.list}
          rowActions={(row) => (
            [
              {
                name: 'Edit', onClick() {
                  openEditWalletPopup({
                    data: row,
                    request: walletRequestUpdate,
                    update
                  })
                },
              },
              {
                name: 'Delete', onClick() {
                  openDeleteWalletPopup({
                    title: 'Are you sure you want to delete this wallet?',
                    request: walletRequestDelete,
                    update
                  })
                },
              }
            ]
          )}
        />
      </>
    )
  }

});
